module.exports = __webpack_public_path__ + "img/serialNumber.83d42a43.svg";